import { useModal, useToast } from "@/comn/hooks";
import { useLogin } from "@/comn/features/authentication/useLogin";
import { api } from "@/comn";
import { useState } from "react";

export const useReactivateAccount = () => {
    const modal = useModal();
    const { logout } = useLogin();
    const { showToast } = useToast();
    const [reactivateAccountForm, setReactivateAccountForm] = useState({ usrId: "", usrEmlAddr: "" });
    const { usrId, usrEmlAddr } = reactivateAccountForm;

    const handleSubmitReactivateAccount = async (event: any) => {
        event.preventDefault();

        try {
            const caseMap: any = {
                tancis: { url: "/api/v1/ptli/mypage/myinfo/reactive/usr", payload: { cstmOfcrNo: usrId, usrEmlAddr } },
                tanesw: {
                    url: "/api/v1/ptle/extptl/mypage/myinfochg/reactive/usr",
                    payload: { xtrnUsrIdntfNo: usrId, usrEmlAddr },
                },
            };

            const key =
                process.env.REACT_APP_SYSTEM_GROUP == "tanoga" ? "tanesw" : process.env.REACT_APP_SYSTEM_GROUP || "";
            const base =
                process.env.REACT_APP_SYSTEM_GROUP == "tancis"
                    ? process.env.REACT_APP_API_PTLI
                    : process.env.REACT_APP_API_PTLE;
            const response = await api.post(base + caseMap[key].url, caseMap[key].payload);

            response.status == 201 &&
                modal.openModal({
                    content:
                        "The request to release the Suspension account is complete.\nThe temporary password has been sent to you by email.",
                    onClose: () => logout(),
                });
        } catch (error: any) {
            console.log(error);
            showToast({ content: error.response?.data?.errorMessage || "error", type: "error" });
        }
    };

    return {
        reactivateAccountForm,
        setReactivateAccountForm,
        handleSubmitReactivateAccount,
    };
};
